import { WbTable } from '@agilelab/plugin-wb-platform';
import { makeStyles } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { MarketplaceSearchResultEnriched } from '../../types';
import { columns } from './columns';
import { Row, adaptData } from './utils';

type SearchResultsTableProps = {
  rows: MarketplaceSearchResultEnriched[];
  loading?: boolean;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      flex: 1,
      paddingRight: theme.spacing(2),
      overflowY: 'scroll',
    },
    descriptionCell: {},
  }),

  { name: 'SearchResultsTable' },
);

export const SearchResultsTable = ({
  rows,
  loading,
}: SearchResultsTableProps) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const adaptedRows = rows.map(row => adaptData(row));

  return (
    <WbTable<Row>
      stickyHeader
      components={{
        tableLoader: {
          rowCount: 30,
          loading: !!loading,
        },
        tableContent: {
          columns,
          rows: adaptedRows,
          onRowClick: res => navigate(res.location),
        },
      }}
      styles={loading ? { container: { overflowY: 'hidden' } } : {}}
      classNames={{ container: classes.root }}
    />
  );
};
